import { API, Auth } from 'aws-amplify';
import * as _ from 'lodash';
// This import loads the firebase namespace along with all its type information.
import firebase from 'firebase/compat/app';
// These imports load individual services into the firebase namespace.
import 'firebase/compat/messaging';
import { toast } from 'react-toastify';

import {
    FETCH_NOTIFICATION,
    FETCH_NOTIFICATION_SUCCESS,
    FETCH_NOTIFICATION_FAIL,

    PAGINATE_NOTIFICATION,
    PAGINATE_NOTIFICATION_SUCCESS,

    NOTIFICATION_SEEN,
    ALL_NOTIFICATION_SEEN_SUCCESS,

    RECEIVE_GENERAL_NOTIFICATIONS,
    RECEIVE_NOTICE_TASK_NOTIFICATION,
    RECEIVE_NOTICE_COMPANY_NOTIFICATION
} from '../actions/types'

import { getTaskById } from '../actions'


export const configurePushNotifications = () => {
    return async (dispatch) => {
        try {
            const initializedFirebaseApp = firebase.initializeApp({
                // Project Settings => Add Firebase to your web app
                apiKey: "AIzaSyDTJbrnS-DXWBXZ2HXe-qZDirxy8ouVUfE",
                projectId: "serviceeasy-d4356",
                messagingSenderId: '230325019364',
                appId: "1:230325019364:web:f4e69832599fc9487e02f1"
            });
            const messaging = initializedFirebaseApp.messaging();

            const permission = await Notification.requestPermission()
            if (permission !== 'granted') {
                throw new Error('Notification permission not granted')
            }
            const token = await messaging.getToken({
                // Project Settings => Cloud Messaging => Web Push certificates
                vapidKey: "BKVh-ujcRWZsn0o36-udQdlKHM9TNWnQ5wMK4hRxvPSiP085lUXJkyx5oUUm2davXawzUy4JmnOTI3nUEN8Wj1E"
            });
            console.log('FCM TOKEN:', token);

            // send token to api, generate platform end point and save in db
            let result = await API.post('UsersAPI', '/token', {
                headers: {
                    Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
                },
                body: { os: 'web', token }
            })
            console.log('Token posting result', result)


            messaging.onMessage((payload) => {
                console.log(payload)
                let data = _.get(payload, "data", {})
                console.log("data:", data)

                // Handle notification data
                if (_.get(data, 'isSeen', false)) {
                    data.isSeen = JSON.parse(data.isSeen);
                }

                // toast notification
                toast.info(data.message)

                handleNotificationData(dispatch, data)
            });
        } catch (error) {
            console.log('configurePushNotifications Error: ', error);
        }

    }

}

const handleNotificationData = async (dispatch, data) => {

    // save notification in notificaiton reducer and increase unread count
    dispatch({
        type: RECEIVE_GENERAL_NOTIFICATIONS,
        payload: { data }
    });

    // Check whether the user is viewing the current task
    const currentPath = window.location.pathname
    const pathArr = currentPath.split("/")
    const isTask = pathArr[1] === 'tasks'
    const isCurrentTask = isTask && (pathArr[2] === data.taskId)
    console.log('isCurrentTask', isCurrentTask)

    // handle specific topics for the task if the user is viewing the task related to the notification
    if (isCurrentTask) {
        switch (data.topic) {
            case 'NOTICE_TASK':
                dispatch({
                    type: RECEIVE_NOTICE_TASK_NOTIFICATION,
                    payload: { taskId: data.taskId, message: data.notice, id: data.id }
                });
                break;
            default:
                dispatch(getTaskById(data.taskId))
                break;
        }
    } else {
        switch (data.topic) {
            case 'NOTICE_COMPANY':
                dispatch({
                    type: RECEIVE_NOTICE_COMPANY_NOTIFICATION,
                    payload: { description: data.description, id: data.id }
                });
                break;
            default:
                break;
        }
    }

}

export const fetchNotifications = (page, pageSize = 20) => {

    return async (dispatch) => {

        if (page === 1) {
            dispatch({ type: FETCH_NOTIFICATION });
        }
        else {
            dispatch({ type: PAGINATE_NOTIFICATION, payload: { page } });
        }

        let configs = {
            queryStringParameters: { pageSize, page },
            headers: {
                Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
            }
        };

        try {
            const response = await API.get('UsersAPI', `/notifications`, configs)
            let notifications = _.get(response, 'data', []);

            if (page > 1) {
                dispatch({ type: PAGINATE_NOTIFICATION_SUCCESS, payload: { notifications } })
            }
            else {
                dispatch({ type: FETCH_NOTIFICATION_SUCCESS, payload: { notifications } })
            }
        } catch (error) {
            console.log(error)
            dispatch({ type: FETCH_NOTIFICATION_FAIL });
        }
    }
};

export const updateNotificationSeenState = (notificationId, isSeen) => {
    return async (dispatch) => {
        if (!isSeen) {
            dispatch({
                type: NOTIFICATION_SEEN,
                payload: { nid: notificationId }
            });
            let postData = {
                body: {},
                headers: {
                    Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
                }
            };
            try {
                await API.put('UsersAPI', `/notifications/${notificationId}`, postData)
            } catch (error) {
                console.log(error)
            }
        } else {
            console.log("notification is already seen")
        }
    }
};

export const updateAllNotificationSeenState = () => {
    return async (dispatch) => {
        let config = {
            body: {},
            headers: {
                Authorization: _.get((await Auth.currentSession()), 'idToken.jwtToken', null)
            }
        };
        try {
            const temp = await API.put('UsersAPI', `/notifications`, config)
            dispatch({
                type: ALL_NOTIFICATION_SEEN_SUCCESS
            });
        } catch (error) {
            console.log(error)
        }
    }
};
